<template>
    <section style="padding:20px 0">
        <el-table :data="list.data" v-loading="loading" border element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="unset">
            <el-table-column prop="school_week_str" label="学周" width="150">
                <template slot-scope="scope">
                    <span>{{scope.row.add_time_str}}</span> <span>{{scope.row.school_week_str}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="title" label="标题" show-overflow-tooltip></el-table-column>
            <el-table-column prop="author.name" label="发布人" show-overflow-tooltip width="100" align="left"></el-table-column>
            <el-table-column prop="class_name" label="班级">
                <template slot="header" slot-scope="scope" v-if="classList&&classList.length>1" style="padding:0px;margin:0px" >
                    <el-select style="width:100%;padding-left:0px;margin-left:0px" size="small" v-model="filters.class_id"  @change="toGetList" placeholder="选择班级" filterable clearable>
                        <el-option v-for="item in classList" :key="item.id" :label="item.full_name" :value="item.id"></el-option>
                    </el-select>
                </template>
            </el-table-column>
            <el-table-column v-if="is_manage" prop="status_str" label="状态" align="left" width="130">
                <template slot="header" slot-scope="scope" style="padding:0px;margin:0px" >
                    <el-select style="width:100%;padding-left:0px;margin-left:0px" size="small" v-model="filters.status"  @change="toGetList" placeholder="选择状态" filterable clearable>
                        <el-option v-for="(item,index) in statusList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </template>
                <template slot-scope="scope">
                    <span>{{scope.row.status_str}}</span><span style="margin-left:5px;color:#999999">{{scope.row.read_count}}</span>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="下载附件">
                <template slot-scope="scope">
                    <p style="width:97%;text-overflow: ellipsis;overflow: hidden;margin-bottom:5px" v-for="(file,index) in scope.row.attachment" :key="index" class="attachment">
                        <a :key="index" :href="file.path+'?attname='+file.name" target="blank"> <i class="el-icon-download"></i>{{file.name }}</a>
                    </p>
                </template>
            </el-table-column>
            <el-table-column label="操作" :align="is_manage?'left':'center'" :width="is_manage?'250':'150'">
                <template slot="header" slot-scope="scope" v-if="is_manage">
                    <el-button type="primary" @click.native="toAdd()" size="small" icon="el-icon-plus">添加</el-button>
                </template>
                <template slot-scope="scope">
                    <el-button type="text" @click="getDetail(scope.row)" style="color:#1890FF">查看详情</el-button>
                    <span v-if="is_manage" style="margin-left:10px">
                        <el-button type="text" @click="toAdd(scope.row.id)"  style="color:#1890FF;">编 辑</el-button>
                        <el-button type="text" @click="revoke(scope.row)" v-if="scope.row.status=='RELASE'&&scope.row.status!='REVOKE'" style="color:#999999;">撤 回</el-button>
                        <el-button type="text" @click="remove(scope.row)"  style="color:#999999" v-if="scope.row.status=='DRAFT'||scope.row.status=='REVOKE'||!scope.row.status">删 除</el-button> 
                        <el-button type="text" @click="release(scope.row)"  v-if="scope.row.status=='DRAFT'||scope.row.status=='REVOKE'||!scope.row.status">发 布</el-button>
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" 
            :current-page="filters.page" :page-sizes="[10,20, 30, 50, 70,100]" :page-size="filters.size"
            layout="total, sizes, prev, pager, next, jumper" :total="list.totalRow">
        </el-pagination>

        <!-- 添加或编辑 -->
        <plan-add ref="addOrUpdate" :classList="classList" :type="type"></plan-add>
    </section>
</template>
<script>
import {schoolClass} from "@/api/server";
import {cms_poster} from "@/api/cms";
import formatter from '@/mixins/formatter'
import planAdd from "@/components/plan/add"

export default {
    props:{
        type:{
            type:String,
            default:'WEEKPLAN',  //RECIPES食谱，WEEKPLAN周计划
        },
        is_manage:{
            type:Boolean,
            default:false
        }
    },
    mixins:[formatter],
    data () {
        return{
            statusList:[
                {id:'',name:'全 部'},
                {id:'RELASE',name:'已发布'},
                {id:'DRAFT',name:'草 稿'},
                {id:'REVOKE',name:'已撤回'},
            ],
            classList:[],
            loading:false,
            filters:{
                page:1,
                size:10,
                type:this.type,
                class_id:null,
                status:null,
            },
            list:{
                data:[],
                totalRow:0,
            },
          
        }
    },

    components:{planAdd},

    methods:{
        getDetail(data){
            if(this.is_manage){
                this.$router.push({name:'planDetail',query:{id:data.id,is_admin:1}});
            }else{
                this.$router.push({name:'planDetail',query:{id:data.id}});
            }
        },
        toAdd(id){
            this.$nextTick(_=>{
                this.$refs.addOrUpdate.openVisible(id);
            })
        },
        
        revoke(data){
            this.$confirm('确定要撤回吗?', '提示', {
                confirmButtonText: '撤 回',
                cancelButtonText: '取 消',
                type: 'warning'
            }).then(() => {
                cms_poster.revoke({id:data.id}).then(res=>{
                    if(res.data){
                        this.$message({ message: '撤回成功！', type: 'success'})
                        this.getList()
                    }
                })
            }).catch(() => {            
            });
        },

        release(data){
            this.$confirm('确定要发布吗?', '提示', {
                confirmButtonText: '发 布',
                cancelButtonText: '取 消',
                type: 'warning'
            }).then(() => {
                cms_poster.release({id:data.id}).then(res=>{
                    if(res.data){
                        this.$message({ message: '发布成功', type: 'success'})
                        this.getList()
                    }
                })
            }).catch(() => {            
            });
        },
        // 移除
        remove(data){
            this.$confirm(`${data.status=='RELASE'?'该计划已发布，':''}确定要删除吗?`, '提示', {
                confirmButtonText: '删 除',
                cancelButtonText: '取 消',
                type: 'warning'
            }).then(() => {
                let promise=cms_poster.remove({id:data.id});
                promise.then(res=>{
                    if(res.data){
                        this.$message({ message:"删除成功！", type: "success" });
                        this.getList();
                    }
                })
            }).catch(() => {            
            });
        },

        findClassByRole(){
            this.classList=[];
     
            schoolClass.getSimpleClassList({range:!this.is_manage}).then(res=>{
                if (res.data) {
                    this.classList=res.data;
                    this.classList.forEach(v=>{
                        v.id=v.class_id
                        v.full_name=v.grade+v.name
                    })
                }   
            })

         
        },

        handleSizeChange(val){
            this.filters.size=val;
            this.toGetList();
        },
        handleCurrentChange(val){
            this.filters.page=val;
            this.getList();
        },
        toGetList(){
            this.filters.page=1;
            this.getList();
        },
        getList(){
            this.loading=true;
            this.filters.status=this.is_manage?this.filters.status:'RELASE';
            let param=this.filters;
            let promise=this.is_manage?cms_poster.paginateForMgr(param):cms_poster.paginate(param)
            promise.then(res=>{
                this.loading=false;
                if(res.data){
                    this.list.totalRow=res.data.totalRow;
                    res.data.list.forEach(v=>{
                        v.add_time_str=this.timeFormatter(v.add_time);
                        v.school_week_str='第'+v.school_week+'周';
                        v.status_str=v.status=='DRAFT'?'草稿':v.status=='RELASE'?'已发布':v.status=='REVOKE'?'已撤回':'已作废';
                        v.class_name=v.class_info?v.class_info.enroll_year+v.class_info.grade+v.class_info.name:'全园食谱';
                    })
                    this.list.data=res.data.list;
                }
            })
        },
    },
    mounted(){
        this.getList();
        this.findClassByRole();
    }
}
</script>

<style scoped lang="scss">
.upload-demo /deep/ .el-icon-document {
  display: inline;
}
.el-select /deep/ .el-input{
    padding-left: 0px;
    padding-right: 0px;
}
</style>


// WEBPACK FOOTER //
// src/components/plan/list.vue